export const translateSizeToMaterialSize = (size)=>{
    switch(size){
        case 'small':
            return 'sm';
        case 'medium':
            return 'md';
        case 'large':
            return 'lg';
        default:
            return 'md';
    }
};
/**
 *  Convert width into a valid css value, as MUI sizing supports various formats
 * https://mui.com/system/sizing/
 */ export const translateSizeToCssValue = (width)=>{
    let adjustedWidth = Number(width) <= 1 && width !== 0 ? `${Number(width) * 100}%` : width;
    if (adjustedWidth === undefined) {
        adjustedWidth = '100%';
    } else if (typeof adjustedWidth === 'number') {
        adjustedWidth = `${adjustedWidth}px`;
    }
    return adjustedWidth;
};

//# sourceMappingURL=translate-size.js.map